module.exports = __webpack_public_path__ + "static/media/3dView9.10.f5603f13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/3dView9.10.jpg
// module id = 204
// module chunks = 0